export enum FormCalendarMobileIcons {
  TIME = 'time-outline',
  CALENDAR = 'calendar-outline',
}
